import { render, staticRenderFns } from "./bind-card.vue?vue&type=template&id=59fe1f4e&scoped=true"
import script from "./bind-card.vue?vue&type=script&lang=js"
export * from "./bind-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fe1f4e",
  null
  
)

export default component.exports